import type { components as definitions, paths } from "@securityjourney/svc-pla/dist/gen/pla";

import { OpenApiFetchWrapper } from "./openApiFetchWrapper";

export type PersonalizedLessonAssignment =
  definitions["schemas"]["securityjourney.proto.pla.PersonalizedLessonAssignment"];
export type TenantPLAResponse =
  definitions["schemas"]["securityjourney.proto.pla.TenantPLAResponse"];
export type UpdatePLAResponse =
  definitions["schemas"]["securityjourney.proto.pla.UpdatePLAResponse"];
export type LessonDetails = definitions["schemas"]["securityjourney.proto.pla.LessonDetails"];
export type PLASource = definitions["schemas"]["securityjourney.proto.pla.PLASource"];
export type LearnerDetails = definitions["schemas"]["securityjourney.proto.pla.LearnerDetails"];

export type AssessmentLessonRecommendation =
  definitions["schemas"]["securityjourney.proto.pla.LessonDetails"];
export type AssessmentTopicRecommendation =
  definitions["schemas"]["securityjourney.proto.pla.AssessmentTopicRecommendation"];
export type AssessmentLessonRecommendationsResponse =
  definitions["schemas"]["securityjourney.proto.pla.AssessmentLessonRecommendationsResponse"];

type UpdatePLARequestBody = NonNullable<
  paths["/svc/pla/{tenant}/{uuid}"]["patch"]["requestBody"]
>["content"]["application/json"];

export class PlaClient extends OpenApiFetchWrapper<paths> {
  constructor() {
    super();
  }

  async getTenantPLAs(tenant: string, directoryUuids?: string[]) {
    return await this.get("/svc/pla/tenant/{tenant}", {
      params: { path: { tenant }, query: { directoryUuids } },
    });
  }

  async updatePLA(tenant: string, uuid: string, body: UpdatePLARequestBody) {
    return await this.patch("/svc/pla/{tenant}/{uuid}", {
      params: { path: { tenant, uuid } },
      body,
    });
  }

  async getAssessmentLessonRecs(tenant: string, examInstanceId: string) {
    return await this.post("/svc/pla/{tenant}/assessment-recommendations", {
      params: { path: { tenant } },
      body: { examInstanceId },
    });
  }
}
